"use client"

import { cn } from "@rarible_int/anaconda_ui_components"
import BaseImage from "next/image"
import { useEffect, useState } from "react"

interface Props {
  imageSrc?: string
  alt: string
  className?: string
  containerClassName?: string
}

export const PLACEHOLDER_IMAGE_SRC = "/images/placeholder.svg"

export function Image({ imageSrc, alt, className, containerClassName }: Props) {
  const [src, setSrc] = useState(imageSrc ?? PLACEHOLDER_IMAGE_SRC)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setSrc(imageSrc ?? PLACEHOLDER_IMAGE_SRC)
  }, [imageSrc])

  return (
    <div className={cn("relative aspect-square w-full", containerClassName)}>
      {loading && (
        <div className="absolute z-10 h-full w-full animate-pulse rounded-md bg-primary/10" />
      )}
      <BaseImage
        className={cn("z-20", className)}
        unoptimized
        src={src}
        key={src}
        alt={alt}
        fill
        onLoadStart={() => {
          setLoading(true)
        }}
        onLoad={() => {
          setLoading(false)
        }}
        onError={() => {
          setSrc(PLACEHOLDER_IMAGE_SRC)
        }}
      />
    </div>
  )
}
